const mobileNav = (options) => {
  if (options === undefined || options.mobileHeaderDiv === null) {
    return;
  }
  const { mobileHeaderDiv } = options;
  const menuBtn = mobileHeaderDiv.querySelector('.mobile-menu > button');
  const menuDiv = mobileHeaderDiv.querySelector('.mobile-flyout');
  const closeBtn = mobileHeaderDiv.querySelector('.mobile-flyout .close-menu-btn');
  const mobileSubmenus = mobileHeaderDiv.querySelectorAll('.subnav-toggle-btn');
  // Hide flyout on load
  if (menuDiv !== null) {
    menuDiv.setAttribute('style', 'display:none;');
  }

  const toggleMobileSubMenuState = (btn, state) => {
    const parent = btn.parentNode.parentNode;
    if (state) {
      parent.classList.remove('subnav-open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      parent.classList.add('subnav-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  const toggleMenuState = () => {
    if (mobileHeaderDiv.classList.contains('open')) {
      mobileHeaderDiv.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
      const timer = setTimeout(() => {
        menuDiv.setAttribute('style', 'display:none;');
        // Close any open submenus, IE 11
        for (let i = 0; i < mobileSubmenus.length; i++) { /* eslint-disable-line no-plusplus */
          toggleMobileSubMenuState(mobileSubmenus[i], true);
        }
        clearTimeout(timer);
      }, 450);
    } else {
      menuDiv.setAttribute('style', 'display:block;');
      const timer = setTimeout(() => {
        mobileHeaderDiv.classList.add('open');
        menuBtn.setAttribute('aria-expanded', 'true');
        clearTimeout(timer);
      }, 150);
    }
  };

  const trapFocus = () => {
    const isVisible = (element) => {
      let el = element;
      while (el) {
        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') {
          return false;
        }
        el = el.parentElement;
      }
      return true;
    };

    const getVisibleFocusable = () => {
      const focusableSelectors = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        '[tabindex]:not([tabindex="-1"])',
      ];

      return Array.from(menuDiv.querySelectorAll(focusableSelectors.join(',')))
        .filter(el => isVisible(el));
    };

    const keydownHandler = (event) => {
      if (event.key === 'Escape') {
        menuDiv.removeEventListener('keydown', keydownHandler);
        toggleMenuState();
        menuBtn.focus();
      }
      if (event.key !== 'Tab') return;

      const focusable = getVisibleFocusable();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      }
      if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    };

    menuDiv.addEventListener('keydown', keydownHandler);

    return {
      deactivate: () => menuDiv.removeEventListener('keydown', keydownHandler),
    };
  };

  // Add events
  // Open Mobile Menu
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      toggleMenuState();
      trapFocus();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      toggleMenuState();
      trapFocus().deactivate();
      menuBtn.focus();
    });
  }
  // Toggle Mobile Submenus
  if (mobileSubmenus) {
    [].map.call(mobileSubmenus, btn => btn.addEventListener('click', (event) => {
      event.preventDefault();
      toggleMobileSubMenuState(btn, btn.parentNode.parentNode.classList.contains('subnav-open'));
    }));
  }
};

export default mobileNav;
